import React, { useState } from 'react';
import { View } from 'react-native';
import DropDownPicker from 'react-native-dropdown-picker';

function Picker({
  selectedValue, onValueChange, children, open: externalOpen, setOpen: externalSetOpen, ...props
}) {
  // Use external open/setOpen if provided, otherwise manage internally
  const [internalOpen, setInternalOpen] = useState(false);
  const isControlled = externalOpen !== undefined && externalSetOpen !== undefined;
  const open = isControlled ? externalOpen : internalOpen;
  const setOpen = isControlled ? externalSetOpen : setInternalOpen;

  const items = React.Children.map(children, (child) => {
    if (child) {
      return {
        label: child.props.label,
        value: child.props.value,
      };
    }
    return null;
  }).filter(Boolean);

  return (
    <DropDownPicker
      dropDownDirection="BOTTOM"
      listMode="FLATLIST"
      open={open}
      value={selectedValue}
      items={items}
      setOpen={setOpen}
      setValue={(setter) => {
        const newValue = typeof setter === 'function' ? setter(selectedValue) : setter;
        onValueChange(newValue);
      }}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    />
  );
}

Picker.Item = function Item({ label, value }) {
  return <View data-label={label} data-value={value} />;
};

export default Picker;
